export default function escapeHeader(options) {
  return {
    onKeyDown(event, change, editor) {
      if (event.key !== 'Enter') return;
      const { value } = editor;
      const { startBlock } = value;
      const { type } = startBlock;
      if (type.indexOf('heading') > -1) {
        event.preventDefault();
        return change.insertBlock({ type: 'paragraph' });
      }
    },
  };
}
